/** Flatten a plain object into a FormData instance (shallow, one entry per key). */
export function jsonToFormData(data: any): FormData {
  const formData = new FormData();
  for (const key in data) {
    formData.append(key, data[key]);
  }
  return formData;
}
